<script type="text/ecmascript-6">
    import Question from "../mixin/Question.vue";

    export default {
        mixins: [
            Question
        ],
        props: {
            title: {
                default(){
                    return 'Collection';
                }
            },
            component_id: {
                default(){
                    return 'collection';
                }
            },
            question: {
                required: true,
            },
            sideVariantLeft: {
                required: true
            },
            sideVariantRight: {
                required: true
            }
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/collection?question=' + this.question + '&side_variant_left=' + this.sideVariantLeft + '&side_variant_right=' + this.sideVariantRight;
            },
            cache_key(){
                return '_' + this.question + '_' + this.sideVariantLeft + '_' + this.sideVariantRight;
            },
            panel_required(){
                return this.filtered_option_list.length > 1;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
